import { render, staticRenderFns } from "./CompassNew.vue?vue&type=template&id=15f8b77a&scoped=true&"
import script from "./CompassNew.vue?vue&type=script&lang=ts&"
export * from "./CompassNew.vue?vue&type=script&lang=ts&"
import style0 from "./CompassNew.vue?vue&type=style&index=0&id=15f8b77a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f8b77a",
  null
  
)

export default component.exports